import React, { useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    InputLabel,
    CircularProgress,
    Modal,

} from "@mui/material";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

export const CrearPortadaNosotros = ({ onclose, fetchSliders }) => {
    const { Token } = useUserAdmin();
    const [loading, setLoading] = useState(false);
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [formData, setFormData] = useState({
        imagen: null,
        titulo: "",
        subtitulo: "",
        parrafo: "",
        parrafo_destacado: "",
        parrafo2: "",
        parrafo2_destacado: "",
        parrafo3: "",
        parrafo3_destacado: "",
        parrafo4: "",
        parrafo4_destacado: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        setFormData({ ...formData, [field]: file });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEnviandoAlert(true)
        const data = new FormData();
        data.append("imagen", formData.imagen);
        data.append("titulo", formData.titulo);
        data.append("subtitulo", formData.subtitulo);
        data.append("parrafo", formData.parrafo);
        data.append("parrafo_destacado", formData.parrafo_destacado);
        data.append("parrafo2", formData.parrafo2);
        data.append("parrafo2_destacado", formData.parrafo2_destacado);
        data.append("parrafo3", formData.parrafo3);
        data.append("parrafo3_destacado", formData.parrafo3_destacado);
        data.append("parrafo4", formData.parrafo4);
        data.append("parrafo4_destacado", formData.parrafo4_destacado);



        try {
            setLoading(true);
            await axios.post(`${backendURL}/api/crear/portada-nosotros`, data, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "multipart/form-data"
                }
            });

            setAlertMessage("Se ha generado con éxito.");
            setEnviandoAlert(false)
            setSuccessAlertOpen(true);


        } catch (error) {
            console.error(error);
            setAlertMessage("Error al crear.");
            setErrorAlertOpen(true);
            setEnviandoAlert(false)
        } finally {
            setLoading(false);
            await fetchSliders()
            setTimeout(() => {
                setSuccessAlertOpen(false);
                setEnviandoAlert(false)
                setErrorAlertOpen(false);
                onclose();

            }, 3000);
        }
    };

    const renderPreview = (file) => {
        return file ? (
            <img
                src={URL.createObjectURL(file)}
                alt="preview"
                style={{
                    width: "100%",
                    maxWidth: "250px",
                    height: "auto",
                    marginBottom: "10px",
                    borderRadius: "8px",
                    border: "2px solid #585857"
                }}
            />
        ) : null;
    };
    return (
        <Box p={3}>
            <Typography variant="h5" gutterBottom sx={{ color: "#585857" }}>
                Crear Nuev portada nosotros
            </Typography>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen </InputLabel>
                    {renderPreview(formData.imagen)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "imagen")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo</InputLabel>

                    <input
                        name="titulo"
                        label="Título"
                        value={formData.titulo}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Subtitulo</InputLabel>

                    <input
                        name="subtitulo"
                        label="Título"
                        value={formData.subtitulo}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo</InputLabel>

                    <input
                        name="parrafo"
                        label="Título"
                        value={formData.parrafo}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo destacado</InputLabel>

                    <input
                        name="parrafo_destacado"
                        label="Título"
                        value={formData.parrafo_destacado}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo dos</InputLabel>

                    <input
                        name="parrafo2"
                        label="Título"
                        value={formData.parrafo2}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo destacado dos</InputLabel>

                    <input
                        name="parrafo2_destacado"
                        label="Título"
                        value={formData.parrafo2_destacado}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo tres</InputLabel>

                    <input
                        name="parrafo3"
                        label="Título"
                        value={formData.parrafo3}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo destacado tres</InputLabel>

                    <input
                        name="parrafo3_destacado"
                        label="Título"
                        value={formData.parrafo3_destacado}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo cuatro</InputLabel>

                    <input
                        name="parrafo4"
                        label="Título"
                        value={formData.parrafo4}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Parrafo destacado cuatro</InputLabel>

                    <input
                        name="parrafo4_destacado"
                        label="Título"
                        value={formData.parrafo4_destacado}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <Button
                    variant="contained"
                    disabled={loading}
                    sx={{
                        backgroundColor: "#5E487B",
                        color: "#fff",
                        textTransform: "capitalize"
                    }}
                    type="submit"
                >    {loading ? <CircularProgress size={24} /> : 'Guardar portada'}

                </Button>
            </form>
            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose style={{ color: '#585857' }} />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de error */}
            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de progreso */}
            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#694B81' }} />
                        <p>Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Box>
    );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px'
};
